export default __webpack_public_path__ + "static/media/newyear3.4bd98b39.png";